var map = {
	"./1-1-1.png": "c580",
	"./1-1.png": "1b20",
	"./1-2-1.png": "21a4",
	"./1-2.png": "ac3c",
	"./1-3-1.png": "1c25",
	"./1-3.png": "16ee",
	"./1-4-1.png": "af16",
	"./1-4.png": "f9cc",
	"./2-1.png": "4f46",
	"./2-2.png": "4be9",
	"./2-3.png": "b005",
	"./3-1-1.png": "907f",
	"./3-1-2.png": "1047",
	"./3-1-3.png": "e153",
	"./3-1-4.png": "939e",
	"./3-1-5.png": "ff3e",
	"./3-2-1.png": "32e4",
	"./3-2-2.png": "9069",
	"./3-2-3.png": "a53f",
	"./3-2-4.png": "6920",
	"./3-2-5.png": "bc1a",
	"./4-1.png": "4f0e",
	"./4-2.png": "b82b",
	"./4-3.png": "d2b7",
	"./4-4.png": "abd1",
	"./Receiving-m.png": "7a55",
	"./Receiving.png": "a734",
	"./bg-m.png": "a216",
	"./bg.png": "4785",
	"./factory-m.png": "8b9d",
	"./factory.png": "8249",
	"./keepGrain-m.png": "a4e8",
	"./keepGrain.png": "0477",
	"./setType-m.png": "393f",
	"./setType.png": "ed26",
	"./store-m.png": "9cbd",
	"./store.png": "f11b",
	"./store/0.png": "45fe",
	"./store/1-1.png": "17a8",
	"./store/1-2.png": "2fe7",
	"./store/1.png": "94dd",
	"./store/2-1.png": "38af",
	"./store/2-2.png": "d9da",
	"./store/2-3.png": "2607",
	"./store/2-4.png": "7569",
	"./store/2.png": "2448",
	"./store/3.png": "e842",
	"./store/4.png": "8145",
	"./store/5.png": "78ec",
	"./store/6.png": "0f40",
	"./video/factory.mp4": "a30d",
	"./video/setType.mp4": "45d0",
	"./video/shop.mp4": "f047",
	"./video/storehouse.mp4": "34a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0ac6";